export default __webpack_public_path__ + "static/media/NFPAimg.d6a8202e.jpg";